'use client';

import type { IconName } from '@/components/entities/Sprite/Icon';
import { Icon } from '@/components/entities/Sprite/Icon';
import { cn } from '@/utils/cn';

interface NavigationItemContentProps {
  label: string;
  icon: IconName;
  variant: 'primary' | 'account';
  isActive?: boolean;
  badge?: string | number;
}

const NavigationItemContent = ({
  label,
  icon,
  variant,
  isActive,
  badge,
}: NavigationItemContentProps) => (
  <>
    <Icon
      name={icon}
      className={cn(
        'size-6 shrink-0 relative',
        variant === 'primary'
          ? 'text-white group-hover:text-c100'
          : 'text-c100 group-hover:text-white',
        isActive && 'text-white',
      )}
    />
    <span
      className={cn(
        'relative',
        variant === 'primary' ? 'group-hover:text-c100' : 'group-hover:text-white',
        isActive && 'text-white',
      )}
    >
      {label}
    </span>
    {typeof badge === 'string' && !!badge && (
      <span className="relative ml-auto shrink-0 rounded-full  bg-primary-1! px-1.5 py-0.5 text-white! paragraph-xs-medium min-w-9.75">
        {badge}
      </span>
    )}
    {typeof badge === 'number' && badge > 0 && (
      <span className="relative ml-auto flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-primary-1 px-1 text-[0.625rem] font-medium leading-4 text-white">
        {badge > 99 ? '99+' : badge}
      </span>
    )}
  </>
);

export default NavigationItemContent;
